import accordion from '@editor/droplets/accordion/droplet.schema';
import audioPlayer from '@editor/droplets/audio-player/droplet.schema';
import audioSeries from '@editor/droplets/audio-series/droplet.schema';
import blogFeed from '@editor/droplets/blog-feed/droplet.schema';
import blogGrid from '@editor/droplets/blog-grid/droplet.schema';
import blogList from '@editor/droplets/blog-list/droplet.schema';
import blogPost from '@editor/droplets/blog-post/droplet.schema';
import button from '@editor/droplets/button/droplet.schema';
import buyButton from '@editor/droplets/buy-button/droplet.schema';
import cardsEvent from '@editor/droplets/cards-event/droplet.schema';
import cardsGeneral from '@editor/droplets/cards-general/droplet.schema';
import cardsStep from '@editor/droplets/cards-step/droplet.schema';
import cardsTall from '@editor/droplets/cards-tall/droplet.schema';
import cardsWide from '@editor/droplets/cards-wide/droplet.schema';
import carousel from '@editor/droplets/carousel/droplet.schema';
import codeGeneral from '@editor/droplets/code-general/droplet.schema';
import columns from '@editor/droplets/columns/droplet.schema';
import contentSlider from '@editor/droplets/content-slider/droplet.schema';
import copyright from '@editor/droplets/copyright/droplet.schema';
import countdown from '@editor/droplets/countdown/droplet.schema';
import divider from '@editor/droplets/divider/droplet.schema';
import footerNav from '@editor/droplets/footer-nav/droplet.schema';
import form from '@editor/droplets/form/droplet.schema';
import googleMap from '@editor/droplets/google-map/droplet.schema';
import grid from '@editor/droplets/grid/droplet.schema';
import groupGrid from '@editor/droplets/group-grid/droplet.schema';
import groupItem from '@editor/droplets/group-item/droplet.schema';
import groupList from '@editor/droplets/group-list/droplet.schema';
import header from '@editor/droplets/header/droplet.schema';
import imageGallery from '@editor/droplets/image-gallery/droplet.schema';
import imageGeneral from '@editor/droplets/image-general/droplet.schema';
import mediaItem from '@editor/droplets/media-item/droplet.schema';
import mediaItemFeed from '@editor/droplets/media-item-feed/droplet.schema';
import mediaItemGrid from '@editor/droplets/media-item-grid/droplet.schema';
import mediaItemList from '@editor/droplets/media-item-list/droplet.schema';
import menuGrid from '@editor/droplets/menu-grid/droplet.schema';
import modal from '@editor/droplets/modal/droplet.schema';
import navigation from '@editor/droplets/navigation/droplet.schema';
import listMenu from '@editor/droplets/list-menu/droplet.schema';
import pdfMenu from '@editor/droplets/pdf-menu/droplet.schema';
import placeCards from '@editor/droplets/place-cards/droplet.schema';
import placeDetails from '@editor/droplets/place-details/droplet.schema';
import placeFeed from '@editor/droplets/place-feed/droplet.schema';
import placeGrid from '@editor/droplets/place-grid/droplet.schema';
import productCard from '@editor/droplets/product-card/droplet.schema';
import productFeature from '@editor/droplets/product-feature/droplet.schema';
import productFeed from '@editor/droplets/product-feed/droplet.schema';
import productGrid from '@editor/droplets/product-grid/droplet.schema';
import profileCards from '@editor/droplets/profile-cards/droplet.schema';
import profileFeed from '@editor/droplets/profile-feed/droplet.schema';
import profileGrid from '@editor/droplets/profile-grid/droplet.schema';
import profileDetails from '@editor/droplets/profile-details/droplet.schema';
import progressBar from '@editor/droplets/progress-bar/droplet.schema';
import projectCards from '@editor/droplets/project-cards/droplet.schema';
import projectFeed from '@editor/droplets/project-feed/droplet.schema';
import projectDetails from '@editor/droplets/project-details/droplet.schema';
import projectGrid from '@editor/droplets/project-grid/droplet.schema';
import serviceCountdown from '@editor/droplets/service-countdown/droplet.schema';
import socialMedia from '@editor/droplets/social-media/droplet.schema';
import table from '@editor/droplets/table/droplet.schema';
import tabs from '@editor/droplets/tabs/droplet.schema';
import textBlob from '@editor/droplets/text-blob/droplet.schema';
import textGeneral from '@editor/droplets/text-general/droplet.schema';
import textSwapper from '@editor/droplets/text-swapper/droplet.schema';
import videoPlayer from '@editor/droplets/video-player/droplet.schema';
import videoSeries from '@editor/droplets/video-series/droplet.schema';
import youTubeVideo from '@editor/droplets/youtube-video/droplet.schema';
export default {
  accordion,
  audioPlayer,
  audioSeries,
  blogFeed,
  blogGrid,
  blogList,
  blogPost,
  button,
  buyButton,
  cardsEvent,
  cardsGeneral,
  cardsStep,
  cardsTall,
  cardsWide,
  carousel,
  codeGeneral,
  columns,
  contentSlider,
  copyright,
  countdown,
  divider,
  footerNav,
  form,
  googleMap,
  grid,
  groupGrid,
  groupItem,
  groupList,
  header,
  imageGallery,
  imageGeneral,
  mediaItem,
  mediaItemFeed,
  mediaItemGrid,
  mediaItemList,
  menuGrid,
  modal,
  navigation,
  listMenu,
  pdfMenu,
  placeCards,
  placeDetails,
  placeFeed,
  placeGrid,
  productCard,
  productFeature,
  productFeed,
  productGrid,
  profileCards,
  profileFeed,
  profileGrid,
  profileDetails,
  progressBar,
  projectCards,
  projectFeed,
  projectDetails,
  projectGrid,
  serviceCountdown,
  socialMedia,
  table,
  tabs,
  textBlob,
  textGeneral,
  textSwapper,
  videoPlayer,
  videoSeries,
  youTubeVideo,
};



// WEBPACK FOOTER //
// ./src/directives/new-droplets.js